var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333V4.375L5.83333 0L11.6667 4.375V7H23.3333V23.3333H0ZM2.33333 21H4.66667V18.6667H2.33333V21ZM2.33333 16.3333H4.66667V14H2.33333V16.3333ZM2.33333 11.6667H4.66667V9.33333H2.33333V11.6667ZM2.33333 7H4.66667V4.66667H2.33333V7ZM7 7H9.33333V4.66667H7V7ZM7 21H21V9.33333H7V21ZM14 14V11.6667H18.6667V14H14ZM14 18.6667V16.3333H18.6667V18.6667H14ZM9.33333 14V11.6667H11.6667V14H9.33333ZM9.33333 18.6667V16.3333H11.6667V18.6667H9.33333Z",
    fill: "#4928FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.0d3f3504916cc2c65d6aec1565628438.svg";
export { ForwardRef as ReactComponent };